import {ProjectExtended} from '../types'
import {usePlannedAccessesCalculations} from './usePlannedAccessesCalculations'
import {getMaxAssencePercentageByProjectType} from '../utils'
import {HttpGetPlannedAccessesDetailResponse} from '@/features/planned-accesses/http/plannedAccesses.http'
import {HttpGetAbsencesResponse} from '@/features/accesses/http/accesses.http'

type UseAbsencesCalculationsProps = {
    project: ProjectExtended
    absences: HttpGetAbsencesResponse['data'] | undefined
    plannedAccesses: HttpGetPlannedAccessesDetailResponse | undefined
}

type UseAbsencesCalculationsReturn = {
    totalAbsencesPaid: number
    totalPlannedTreatments: number
    percentage: number
    maxAbsencePercentage: number
    totalAbsencesAllowed: number
}

export const useAbsencesCalculations = ({
    project,
    absences,
    plannedAccesses
}: UseAbsencesCalculationsProps): UseAbsencesCalculationsReturn => {
    const totalAbsencesPaid =
        absences?.filter(absence => absence.payOutcome === 'absence_20' || absence.payOutcome === 'absence_50')
            .length ?? 0

    const {totalPlannedTreatments} = usePlannedAccessesCalculations(project.durationDays ?? 0, plannedAccesses)

    const percentage =
        totalAbsencesPaid && totalPlannedTreatments ? Math.round((totalAbsencesPaid / totalPlannedTreatments) * 100) : 0

    const maxAbsencePercentage = getMaxAssencePercentageByProjectType(project)

    const totalAbsencesAllowed = Math.floor(totalPlannedTreatments * (maxAbsencePercentage / 100))

    return {
        totalAbsencesPaid,
        totalPlannedTreatments,
        percentage,
        maxAbsencePercentage,
        totalAbsencesAllowed
    }
}
